import { createGlobalStyle } from 'styled-components/macro'

const GlobalStyle = createGlobalStyle`
*{
  margin: 0;    
  padding: 0;
  list-style: none;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
}
html{
  font-size: 20px;
}
body{
  background: #ffffff;
  color: #1D1D1D;
  font-family: 'Montserrat', 'Roboto', sans-serif;
}
a{
    color: inherit;
    text-decoration: none;
}
button{
    cursor: pointer;
    outline: none;
}

footer{
    margin-top: 3rem;
    font-size: 12px;
    text-align: center;
}

nav{
    float: right;
}

tr:hover{
    background-color: #f2f2f2;
}

#root{
    height: 100%;
}
`

export default GlobalStyle
